import { trim } from '~/helpers/strings'

export async function stringifyHtml (html: string, maxLength?: number): Promise<string | undefined> {
  if (!html) {
    return undefined
  }

  if (process.server) {
    const { stripHtml } = await import('string-strip-html')
    return trim(stripHtml(html).result, maxLength)
  }

  const wrapper = document.createElement('div')
  wrapper.innerHTML = html
  return trim(wrapper.innerText, maxLength)
}
